import { FormattedMessage } from '@ori/i18n';
import type { FC } from 'react';

import type { IFormattedMessageProps } from '../interfaces';

export const Localization: FC<IFormattedMessageProps> = (props) => {
  const { id, defaultMessage, values } = props;

  return (
    <span
      data-key={id}
      className="translate"
    >
      <FormattedMessage
        key={id}
        id={id}
        defaultMessage={defaultMessage}
        values={values}
      />
    </span>
  );
};
